import src from "IMAGE";
export default { src, width: 456, height: 234, blurWidth: 0, blurHeight: 0};
